



import { Component as NodeComponent } from 'vue'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { SetProductPageParams } from '@/types/newPersion'
import InputPage from '@/views/newPension/pensionCard/investCard/inputPage.vue'
import EditPage from '@/views/newPension/pensionCard/investCard/edit.vue'
import OutputPage from '@/views/newPension/pensionCard/investCard/outPage.vue'
import InvestCfg from '@/views/newPension/pensionCard/investCard/config'
@Component({
  components: {
    InputPage,
    OutputPage,
    EditPage
  }
})
export default class extends Vue {
    @Prop() type !: string | null
    @Prop() tabInfo !: {}
    @Prop() getTopChartAndTableFn !: Function

    InvestCfg = InvestCfg
    page: NodeComponent = InputPage
    editParams: SetProductPageParams | null = null

    // 检测父组件状态(切换状态 或者 点击添加按钮)
    @Watch('type')
    handleChangeType (val: string | null) {
      let _type = ''
      if (val) {
        _type = val
      } else {
        _type = 'input'
      }
      this.handleClick(_type)
    }

    handleClick (type: string, params: SetProductPageParams | null = null) {
      switch (type) {
        case 'output':
          this.page = OutputPage
          break
        case 'setting':
          this.handleSetting(params)
          this.page = EditPage
          break
        case 'input':
          this.page = InputPage

          break
        case 'back':
          this.$emit('on-edit-btn', 'homePage', 2)
          break
      }
    }

    handleSetting (editParams: SetProductPageParams | null = null) {
      // this.page = EditPage
      // if (params) {
      //   this.editParams = params
      // } else {
      //   this.editParams = null
      // }
      this.$emit('on-add-setting-page', EditPage, { proCfg: this.InvestCfg, editParams })
    }
}
